module.exports = __webpack_public_path__ + "static/media/swedish.1f642770.svg";